import { useEffect, useState } from "react";
import axios from "axios";
import { Check, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminDeletions = ({ adminKey }) => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(null);
  const headers = { "X-Admin-Key": adminKey };

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/admin/deletion-requests`, { headers });
      setRows(Array.isArray(data) ? data : []);
    } catch {
      setRows([]);
    }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const complete = async (id) => {
    if (!window.confirm("Mark this request as completed? Only do this after the account and data have been deleted.")) return;
    setBusy(id);
    try {
      await axios.put(`${API}/admin/deletion-requests/${id}`, { status: "completed" }, { headers });
      toast.success("Marked as completed.");
      await load();
    } catch {
      toast.error("Could not update request.");
    } finally {
      setBusy(null);
    }
  };

  if (!rows) return <Loader2 className="h-5 w-5 animate-spin text-white/50" />;
  return (
    <div data-testid="admin-deletions" className="space-y-4">
      <p className="max-w-2xl text-sm text-white/55">Requests from zenvio.dk/delete-account. Delete the user's account and data in the app, e-mail them a confirmation, then mark the request as completed. Deadline: 30 days.</p>
      {rows.length === 0 && <p className="text-white/50">No deletion requests.</p>}
      {rows.map((r) => {
        const due = new Date(new Date(r.created_at).getTime() + 30 * 864e5);
        return (
          <div key={r.id} data-testid="admin-deletion-item" className="glass flex flex-wrap items-center justify-between gap-4 rounded-3xl p-6">
            <div className="min-w-0">
              <p className="font-display text-lg font-semibold"><a href={`mailto:${r.email}`} className="text-[#22d3ee]">{r.email}</a></p>
              <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-white/45">{r.app} · {r.lang} · {new Date(r.created_at).toLocaleString()}{r.status === "pending" && ` · due ${due.toLocaleDateString()}`}</p>
              {r.message && <p className="mt-3 whitespace-pre-wrap text-sm text-white/70">{r.message}</p>}
            </div>
            {r.status === "completed" ? (
              <span data-testid="admin-deletion-status" className="inline-flex items-center gap-2 rounded-full border border-[#5cf2a0]/30 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-[#5cf2a0]"><Check className="h-3.5 w-3.5" />Completed</span>
            ) : (
              <button type="button" onClick={() => complete(r.id)} disabled={busy === r.id} data-testid="admin-deletion-complete-button" className="btn-primary !py-2 text-sm disabled:opacity-50">
                {busy === r.id ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />} Mark completed
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};
